import React, { useState } from "react";
import MessageBar from "./MessageBar";
import styled from "styled-components";
import MessageContent from "./MessageContent";
import MessagePostForm from "./MessagePostForm";

const StyledDivContainer = styled.div``;

export default function MessagePost({ message, replyToMessageId, isReply }) {
  const [disableReplyButton, setDisableReplyButton] = useState(false);
  const [showReplyForm, setShowReplyForm] = useState(false);

  const handleShowForm = () => {
    setDisableReplyButton(true);
    setShowReplyForm(true);
  };

  const handleHideForm = () => {
    setShowReplyForm(false);
    setDisableReplyButton(false);
  };

  return (
    <StyledDivContainer>
      <MessageBar message={message} />
      <MessageContent
        message={message}
        handleShowForm={handleShowForm}
        disableReplyButton={disableReplyButton}
      />
      {showReplyForm && (
        <MessagePostForm
          handleHideForm={handleHideForm}
          replyToMessageId={replyToMessageId}
          isReply={isReply}
        />
      )}
    </StyledDivContainer>
  );
}
